import { RefreshCwIcon } from "lucide-react";
import React, { useState, useEffect } from "react";

const generatePassKey = () => {
  return Math.floor(1000 + Math.random() * 9000).toString(); 
};

const EventForm = ({ createFolder }) => {
  const [eventName, setEventName] = useState("");
  const [eventDate, setEventDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [eventType, setEventType] = useState("");
  const [description, setDescription] = useState("");
  const [passKey, setPassKey] = useState(generatePassKey());
  const [shareKey, setShareKey] = useState(generatePassKey());

  // Regenerate pass key if user clicks refresh
  const handleGenerateKey = () => {
    setPassKey(generatePassKey());
  };

  const handleGenerateShareKey = () => {
    setShareKey(generatePassKey());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newEvent = { name: eventName, date: eventDate, category:eventType, description: description, pass_key: passKey, share_key: shareKey };
    createFolder(newEvent);

    // Reset form after submit
    setEventName("");
    setEventDate(new Date().toISOString().split("T")[0]);
    setEventType("");
    setDescription("");
    setPassKey(generatePassKey());
  };

  return (
    <div className="max-w-3xl mx-auto bg-white p-6 rounded-2xl shadow-md mt-6">
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Name + Date row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Event Name
            </label>
            <input
              type="text"
              placeholder="Enter event name"
              value={eventName}
              onChange={(e) => setEventName(e.target.value)}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Event Date
            </label>
            <input
              type="date"
              value={eventDate}
              onChange={(e) => setEventDate(e.target.value)}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
              required
            />
          </div>
        </div>

        {/* Pass Key */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Event Pass Key
            </label>
            <div className="flex items-center gap-2">
              <input
                type="text"
                value={passKey}
                readOnly
                className="mt-1 flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm bg-gray-100 cursor-not-allowed"
              />
              <button
                type="button"
                onClick={handleGenerateKey}
                className="px-3 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded-lg">
                <RefreshCwIcon className="h-4 w-4" />
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Share this pass key with guests to access the event.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Event Pass Key
            </label>
            <div className="flex items-center gap-2">
              <input
                type="text"
                value={shareKey}
                readOnly
                className="mt-1 flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm bg-gray-100 cursor-not-allowed"
              />
              <button
                type="button"
                onClick={handleGenerateShareKey}
                className="px-3 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded-lg">
                <RefreshCwIcon className="h-4 w-4" />
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Share this pass key with guests to access the event.
            </p>
          </div>
        </div>
        {/* Event Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Event Type
          </label>
          <select
            value={eventType}
            onChange={(e) => setEventType(e.target.value)}
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
            required>
            <option value="">Select type</option>
            <option value="Wedding">Wedding</option>
            <option value="Engagement">Engagement</option>
            <option value="Baby Shower">Baby Shower</option>
            <option value="Birthday">Birthday</option>
            <option value="Anniversary">Anniversary</option>
            <option value="Other">Other</option>
          </select>
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            rows="3"
            placeholder="Enter event details..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"></textarea>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded-lg transition">
          Create Event
        </button>
      </form>
    </div>
  );
};

export default EventForm;
